function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState, useCallback } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { AccordionSection } from "../components/AccordionSection";
import { ICON_PLACEMENT } from "../components/AccordionIcon";
import { useDeprecatedComponentMessage } from "../../../utils";
export function Accordion(_param) {
    var _sections = _param.sections, sections = _sections === void 0 ? [] : _sections, _chevronPlacement = _param.chevronPlacement, chevronPlacement = _chevronPlacement === void 0 ? ICON_PLACEMENT.END : _chevronPlacement, _allowMultipleOpen = _param.allowMultipleOpen, allowMultipleOpen = _allowMultipleOpen === void 0 ? true : _allowMultipleOpen, _isCollapsible = _param.isCollapsible, isCollapsible = _isCollapsible === void 0 ? true : _isCollapsible, _testID = _param.testID, testID = _testID === void 0 ? 'accordion' : _testID, onSectionClicked = _param.onSectionClicked, children = _param.children, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _paddingMode = _param.paddingMode, paddingMode = _paddingMode === void 0 ? 'normal' : _paddingMode, transitionProps = _param.transitionProps, props = _objectWithoutProperties(_param, [
        "sections",
        "chevronPlacement",
        "allowMultipleOpen",
        "isCollapsible",
        "testID",
        "onSectionClicked",
        "children",
        "isRtl",
        "paddingMode",
        "transitionProps"
    ]);
    useDeprecatedComponentMessage({
        date: 'the Carina V3 Release',
        componentName: 'Accordion',
        upgradeURL: 'https://carina.docs.cvent.org/blog/2023-04-11-accordion_NEXT'
    });
    var ref = _slicedToArray(useState(), 2), currentFocus = ref[0], setCurrentFocus = ref[1];
    var ref1 = _slicedToArray(useState(sections.reduce(function(accumulator, section, index) {
        return section.expandedByDefault ? _toConsumableArray(accumulator).concat([
            index
        ]) : accumulator;
    }, [])), 2), openedSections = ref1[0], setOpenedSections = ref1[1];
    var onClick = useCallback(function(index) {
        setOpenedSections(function(openSect) {
            if (openSect.includes(index)) {
                return openSect.filter(function(idx) {
                    return idx !== index;
                });
            }
            if (allowMultipleOpen) {
                return _toConsumableArray(openSect).concat([
                    index
                ]);
            }
            return [
                index
            ];
        });
    }, [
        allowMultipleOpen
    ]);
    var handleArrowKeyPress = function(iterateBy, event) {
        event.preventDefault();
        event.stopPropagation();
        var optionsLength = sections.length - 1;
        var getNextFocusable = function(optionIndex) {
            var startTopOrBottom = iterateBy === -1 ? optionsLength : 0;
            return optionIndex === null ? startTopOrBottom : optionIndex + iterateBy;
        };
        if (currentFocus && (iterateBy === 1 && currentFocus < optionsLength || iterateBy === -1 && currentFocus > 0)) {
            setCurrentFocus(getNextFocusable(currentFocus));
        }
    };
    return _jsxs("div", _objectSpread({}, injectTestId(testID), {
        children: [
            children,
            sections.map(function(section, index) {
                return _jsx(AccordionSection, _objectSpread({
                    index: index,
                    isOpen: openedSections.includes(index),
                    isCollapsible: isCollapsible,
                    chevronPlacement: chevronPlacement,
                    focused: currentFocus === index,
                    onClick: function(i) {
                        onClick(i);
                        setCurrentFocus(index);
                        if (onSectionClicked) {
                            onSectionClicked(i);
                        }
                    },
                    testID: testID,
                    isRtl: isRtl,
                    handleArrowKeyPress: handleArrowKeyPress,
                    paddingMode: paddingMode,
                    transitionProps: function(defaultProps) {
                        return typeof transitionProps === 'function' ? transitionProps(defaultProps, section) : _objectSpread({}, defaultProps, transitionProps);
                    }
                }, section, props), "".concat(testID, "-section-").concat(index));
            })
        ]
    }));
}
export default Accordion;
